import React, { useRef, useEffect } from 'react';

const MandatoryFormItem = ({ label, value, setter, type, fieldErrors }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (fieldErrors.includes(type)) ref.current.scrollIntoView({ behavior: 'smooth' });
  }, [fieldErrors]);
  return (
    <div className={`form-item ${fieldErrors.includes(type) ? 'errored' : ''}`} ref={ref}>
      <label>
        {label} <span className="star">*</span>
      </label>
      <input type="text" className={type} value={value} onChange={e => setter(e.target.value)} />
    </div>
  );
};

export default MandatoryFormItem;
